import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import * as Rx from "rxjs"
import { retry } from "rxjs/operators"
import { request } from "../utils/http"

export type GetUserAccountServerResponse = {
    content: UserAccountResponseItem[]
    total_count: number
    page_size: number
}

export type UserAccountLocationServerItem = {
    id: string
    location_id: string
    user_account_id: string
    version: number
}

export type UserAccountRoleServerItem = {
    id: string
    role_id: string
    salary_rate: number
    user_account_id: string
    rate_type: Maybe<string>
    version: number
}

export type UserAccountAddressServerItem = {
    id: string
    version: number
    deleted: boolean
    line1: Maybe<string>
    line2: Maybe<string>
    state: Maybe<string>
    city: Maybe<string>
    zip: Maybe<string>
    country: Maybe<string>
    origin_user_account_id: string
    origin_terminal_id: string
    origin_timestamp: string
    user_account_id: string
}

export type UserAccountNoteServerItem = {
    id: string
    version: number
    note: string
    deleted: boolean
    origin_user_account_id: string
    origin_timestamp: string
    user_account_id: string
    origin_user_name: string
}

export type UserAccountResponseItem = {
    id: string
    account_id: string
    deleted: boolean
    email: string
    first_name: string
    middle_name?: string
    surname: string
    is_active: boolean
    location_ids: string[]
    locations?: UserAccountLocationServerItem[]
    phone: string
    pin: string
    access_card_key: Maybe<string>
    roles?: UserAccountRoleServerItem[]
    user_id: string
    user_version: string
    access_level_id: string
    access_level_account_id: string
    date_of_birth: string
    ssn: string
    gender: string
    version: number
    addresses?: UserAccountAddressServerItem[]
    emergency_contact_name: string
    emergency_contact_means: string
    inactive_reason: string
    notes?: UserAccountNoteServerItem[]
    employee_number: Maybe<string>
}

export const getUserAccountApi = (
    headers: Record<string, any>,
    parameters: Record<string, any> = {}
): Rx.Observable<GetUserAccountServerResponse> =>
    Rx.defer(() =>
        request({
            method: "GET",
            path: "/data/user-account",
            parameters: parameters,
            headers: headers,
        })
    ).pipe(retry(3))
